import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import DashboardLayout from "../../components/DashboardLayout/DashboardLayout";
import { getApiUrl } from "../../config/apiConfig";
import "./Blogs.css";

const Blogs = () => {

  const pageSize = 9;

  const [blogs, setBlogs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);

  useEffect(() => {
    fetchBlogs();
  }, [currentPage]);

  const fetchBlogs = async () => {

    try {

      setLoading(true);
      setError(null);

      const response = await fetch(
        getApiUrl("/Trans/API/GetBlogsList"),
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "Authorization":
              `Bearer ${localStorage.getItem("authToken")}`
          },
          body: JSON.stringify({
            status: 0,
            pageNo: currentPage,
            pageSize: pageSize
          })
        }
      );

      const data = await response.json();

      const mappedBlogs =
        data.items?.map(item => ({

          id: item.id,
          title: item.title,
          excerpt: item.summary,
          createdAt: item.createdDate,
          category: item.blogCategoryName,
          featuredImage:
            item.blogFileUrl
              ? getApiUrl("/" + item.blogFileUrl)
              : null,
          slug: item.code

        })) || [];

      setBlogs(mappedBlogs);

      const pages = Math.ceil(
        data.totalRecords / pageSize
      );

      setTotalPages(pages);

    }
    catch (error) {

      console.error(error);

      setError("Failed to load blogs");

    }
    finally {

      setLoading(false);

    }

  };

return (

  <DashboardLayout>

    <div className="blogs-page">

      {/* Professional Header */}

      <div className="blogs-header">

        <div className="header-left">

          <h2>Medical Articles & Health Tips</h2>

          <p>
            Trusted health insights from experienced professionals
          </p>

        </div>

        <Link
          to="/dashboard/create-blog"
          className="create-blog-btn"
        >
          + Create Blog
        </Link>

      </div>

      {/* Loading */}

      {loading ? (

        <div className="loading-state">
          <div className="spinner"></div>
          <p>Loading medical articles...</p>
        </div>

      ) : (

        <>

          {/* Blog Grid */}

          <div className="blogs-grid">

            {blogs.map(blog => (

              <article
                key={blog.id}
                className="blog-card"
              >

                {/* Image Section */}

                <div className="blog-image">

                  {blog.featuredImage ? (

                    <img
                      src={blog.featuredImage}
                      alt={blog.title}
                    />

                  ) : (

                    <div className="image-placeholder">
                      🏥
                    </div>

                  )}

                  <span className="category-badge">
                    {blog.category}
                  </span>

                </div>

                {/* Content */}

                <div className="blog-content">

                  <h3>
                    {blog.title}
                  </h3>

                  <p className="blog-excerpt">
                    {blog.excerpt}
                  </p>

                  <div className="blog-footer">

                    <span className="blog-date">

                      {new Date(
                        blog.createdAt
                      ).toLocaleDateString(
                        "en-US",
                        {
                          year: "numeric",
                          month: "short",
                          day: "numeric"
                        }
                      )}

                    </span>

                    <Link
                      to={`/blog/${blog.slug}`}
                      className="read-more-btn"
                    >

                      Read More →

                    </Link>

                  </div>

                </div>

              </article>

            ))}

          </div>

          {/* Pagination */}

          {totalPages > 1 && (

            <div className="pagination">

              <button
                disabled={currentPage === 1}
                onClick={() =>
                  setCurrentPage(prev => prev - 1)
                }
              >
                Previous
              </button>

              {Array.from(
                { length: totalPages },
                (_, i) => i + 1
              ).map(page => (

                <button
                  key={page}
                  className={
                    currentPage === page
                      ? "active"
                      : ""
                  }
                  onClick={() =>
                    setCurrentPage(page)
                  }
                >
                  {page}
                </button>

              ))}

              <button
                disabled={
                  currentPage === totalPages
                }
                onClick={() =>
                  setCurrentPage(prev => prev + 1)
                }
              >
                Next
              </button>

            </div>

          )}

        </>

      )}

    </div>

  </DashboardLayout>

);

};

export default Blogs;